<div class="login-wrapper" >
<div class="container-fluid h-100" style="max-width: 600px; margin-top: 10px;margin-bottom: 30px;">
    <div class="row h-100" >
            <div>
                <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
                    <div class="top-logo"><img src="assets/logo.svg" /></div>
                    <p-card header="Register" class="header">
                        <div class="row">
                            <div class="field col-sm-12 col-md-12 custom-width col-lg-6 ">
                                <label for="first_name">First name</label>
                                <input type="text" pInputText class="input" formControlName="first_name"
                                    name="first_name" placeholder="Enter your First name" maxlength="50"/>

                                <small *ngIf="first_name.invalid && (first_name.dirty||first_name.touched)"
                                    class="small-error">
                                    <div *ngIf=" !first_name.errors?.['required']">*First name should be valid</div>
                                    <div *ngIf="first_name.errors?.['required']">*First name is required</div>

                                </small>
                            </div>

                            <div class="field col-sm-12 col-md-12 custom-width col-lg-6">
                                <label for="last_name">Last name</label>
                                <input type="text" pInputText formControlName="last_name" class="input" name="last_name"
                                    placeholder="Enter your Last name" maxlength="50"/>

                                <small *ngIf="last_name.invalid && (last_name.dirty||last_name.touched)"
                                    class="small-error">
                                    <div *ngIf="last_name.errors?.['required']">*Last name is required</div>

                                    <div *ngIf="!last_name.errors?.['required']">Last name should be valid</div>
                                </small>
                            </div>
                            <div class="field col-sm-12 col-md-12 custom-width col-lg-6">
                                <label for="email">Email</label>
                                <input type="email" pInputText formControlName="email" class="input" name="email"
                                    placeholder="Enter your email" [readonly]="!emailmodel.canEditEmail" />
                                <small *ngIf="email.invalid && (email.dirty || email.touched)" class="small-error">
                                    <div *ngIf="email.hasError('required')">* Email is required</div>
                                    <div *ngIf="email.hasError('pattern')">* Enter a valid email address</div>
                                </small>
                            </div>

                            <div class="field col-sm-12 col-md-12 custom-width col-lg-6">
                                <label for="phone_number">Phone number:</label>
                                <input type="text" id="phone_number" class="input" name="phone_number"
                                    placeholder="Phone number" formControlName="phoneNumber"
                                    (input)="formatPhoneNumber($event)" maxlength="12">
                                <small *ngIf="showPhoneNumberError" class="small-error">Phone number must be 10 digits
                                    long</small>
                            </div>
                            <div class="field col-sm-12 col-md-12 col-lg-6 custom-width">
                                <label for="password">Password</label>
                                <div class="input-group">
                                    <input [type]="hidePassword ? 'password' : 'text'" pInputText formControlName="password" class="input"
                                        name="password" placeholder="Enter your password" />
                                    <mat-icon class="eye-icon" (click)="hidePassword = !hidePassword">
                                        {{ hidePassword ? 'visibility_off' : 'visibility' }}
                                    </mat-icon>
                                </div>
                                <small *ngIf="password.invalid && (password.dirty || password.touched)"
                                    class="small-error">
                                    <div *ngIf="password.errors?.['required']">password is required</div>
                                    <div *ngIf="password.errors?.['minlength']">password should be at least 6 characters
                                    </div>
                                </small>
                            </div>
                            <div class="field col-sm-12 col-md-12 col-lg-6 custom-width">
                                <label for="confirmpassword">Confirm password</label>
                                <div class="input-group">
                                    <input [type]="hideConfirmPassword ? 'password' : 'text'" pInputText formControlName="confirmpassword" class="input"
                                        name="confirmpassword" placeholder="Confirm password" />
                                    <mat-icon class="eye-icon" (click)="hideConfirmPassword = !hideConfirmPassword">
                                        {{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}
                                    </mat-icon>
                                </div>
                                <small
                                    *ngIf="isConfirmpasswordError(registerForm) && (confirmpassword.dirty || confirmpassword.touched)"
                                    class="small-error">
                                    password not match
                                </small>
                            </div>


                            <div class="field">
                                <small *ngIf="errorMessage" class="small-error">
                                    {{errorMessage}}
                                </small>
                            </div>

                            <div class="field col-sm-12 col-md-12 col-lg-6 custom-width">
                                <label for="gender" class="gender-option">Gender: </label>
                                <div class="d-flex flex-wrap">
                                    <div class="radio-option d-flex align-items-center p-2">
                                        <input type="radio" id="male" formControlName="gender" value="male"
                                            class="gender-option me-1">
                                        <label for="male" style="margin-bottom: 5px;">Male</label>
                                    </div>
                                    <div class="radio-option d-flex align-items-center p-2">
                                        <input type="radio" id="female" formControlName="gender" value="female"
                                            class="gender-option me-1">
                                        <label for="female" style="margin-bottom: 5px;">Female</label>
                                    </div>
                                </div>


                                <small *ngIf="gender.invalid && (gender.dirty || gender.touched)" class="small-error">
                                    <div *ngIf="gender.errors?.['required']">* Select gender</div>
                                </small>
                            </div>

                            <div class="field col-sm-12 col-md-12 col-lg-6 custom-width">
                                <label for="zip">Zipcode</label>
                                <input type="text" pInputText class="input" formControlName="zip" name="zip"
                                    placeholder="Enter your zipcode" inputmode="numeric" pattern="[0-9]*"
                                    maxlength="5" (input)="onZipInput($event)" autocomplete="postal-code" />

                                <small *ngIf="zip.invalid && (zip.dirty||zip.touched)" class="small-error">
                                    <div *ngIf="zip.errors?.['pattern']">Enter valid 5 digit zip</div>
                                    <div *ngIf="zip.errors?.['required']">*Zipcode is required</div>
                                </small>
                            </div>

                                                     <div class="field">
                                                                <label for="dob">Date of Birth</label>
                                                                <mat-form-field appearance="outline" class="custom-date-field-black w-full">
                                                                        <input matInput [matDatepicker]="picker" placeholder="MM/DD/YYYY" formControlName="dob" [max]="today" />
                                                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                                        <mat-datepicker #picker></mat-datepicker>
                                                                </mat-form-field>
                                                                <small *ngIf="dob?.invalid && (dob?.touched || dob?.dirty)" class="small-error">
                                                                    <div *ngIf="dob?.errors?.['required']">* Select DOB</div>
                                                                </small>
                                                        </div>

                            <div>
                                <button type="submit" class="registerBtn create-btn mt-4"
                                    [disabled]="registerForm.invalid"><span>Register</span><span></span></button>
                            </div>
                            <div class="register-now">
                                <span>Already a member?</span><a routerLink="/login" class="loginLink text-underline">
                                    Login</a>
                            </div>

                            <!-- <input type="submit" value="Register" class="registerBtn" [disabled]="registerForm.invalid"> -->
                            <!-- <p>{{jsonData}}</p> -->
                        </div>
                    </p-card>
                </form>
            
    </div>

</div>
</div>